import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="px-4 md:px-10 py-16 md:py-20 bg-background-100 border-y border-background-200" aria-label="常见问题">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="text-xs tracking-[0.3em] text-primary-600 font-medium">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">常见问题</h2>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            关于专题怎么整理、榜单怎么排序、内容能否转载，这里集中回答最常被问到的几个问题。
          </p>
          <div className="mt-6 rounded-lg bg-background-50 border border-background-200 p-5">
            <p className="text-sm text-foreground-700 leading-relaxed">
              还有别的疑问？写信到
              <span className="text-primary-600 font-medium"> hello@heiliaoshe.example.com</span>
              我们会尽快回复。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <dl className="divide-y divide-background-200 border-t border-background-200">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div key={item.q} className="py-1">
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                      className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
                    >
                      <span className="flex items-start gap-4">
                        <span className="font-heading text-sm text-primary-500 pt-0.5">
                          {String(idx + 1).padStart(2, '0')}
                        </span>
                        <span className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`text-xl text-foreground-500 mt-0.5 transition-transform ${
                          isOpen ? 'ri-subtract-line text-primary-500' : 'ri-add-line'
                        }`}
                      ></i>
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="pb-6 pl-8 md:pl-9 pr-4 text-sm leading-relaxed text-foreground-600">{item.a}</dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}